<template>
  <div>
    <v-row class="also_liked-row">
      <h2 class="H2">{{ $t('pages.content.people_also_liked') }}</h2> <!--TODO get text of global configuration-->
    </v-row>
    <v-layout class="page_navigation-row featured-page__container">
      <page-in-navigation
        v-for="relatedPage in relatedPages"
        :key="relatedPage.page.id"
        :page="relatedPage.page"
        :insideFeatured="true"
        class="ma-2"
      />
    </v-layout>
  </div>
</template>
<script>
export default {
  props: {
    relatedPages: {
      type: Array,
      default: [],
    },
  }, 
  components: {
    PageInNavigation: () => import('@/components/view-components/webapp-pages/PageInNavigation.vue'),
  },
}
</script>
<style scoped>
.also_liked-row {
  padding: 40px 12px 10px;
}

.page_navigation-row {
  padding: 20px 0px 20px 0px !important;
}
</style>